$(document).ready(function () {
    jQuery(document).on('click', function (e) {
        var containermenu = $('.content-header.active');
        if (!containermenu.is(e.target)  && !$(".megamenu-mobile.hidden-config").is(e.target)// if the target of the click isn't the container...
            && containermenu.has(e.target).length === 0) // ... nor a descendant of the container
        {
            $('body').removeClass('active-body');
            $('.content-header').removeClass('active');
            $('.li-nav-section-0').removeClass('activelv1');
            $('.sub-menu.sub-menu-container h4').removeClass('activelv3');
            $('span.hidden-config.js-click-config').removeClass('activelv3');
        }
    });
    $('.megamenu-mobile.hidden-config').click(function() {
        $(this).parent().parent().addClass('active');
        $('body').addClass('active-body');
    });
    $('.menu-title.hidden-config').click(function() {
        $('body').removeClass('active-body');
        $('.content-header').removeClass('active');
    });
    $('span.hidden-config.click-sub-mobile1').click(function() {
        $(this).parent().addClass('activelv1');
    });
    $('span.hidden-config.click-sub-mobile2').click(function() {
        $('.li-nav-section-0').removeClass('activelv1');
    });
    $('h4.title-content-menu.title').click(function() {
        $(this).toggleClass('activelv3');
    });
    $('#myTab').parent().on('click',function() {
        $('.nav-item').toggleClass('showcontent');
        $(document).click(function(e){
            if(!$(e.target).is('#myTab, #myTab *')){
                if($('.nav-item').hasClass( "showcontent" ));
                {
                    $('.nav-item').removeClass('showcontent');
                }
            }
        });
    });
    $('.nav-tabs .nav-item').click(function() {
        $(this).siblings('.nav-item').removeClass('active');
        $(this).addClass('active');
    });
    $('span.hidden-config.js-click-config').click(function() {
        $(this).parent().toggleClass('activelv2');
    });


    var alterClass = function() {
        var ww = document.body.clientWidth;
        if (ww <= 767) {
            $('.nav-item:nth-child(1)').addClass(' active');
        } else if (ww > 767) {
            $('.nav-item:nth-child(1)').removeClass(' active');
        };
    };
    $(window).resize(alterClass());

});





